<template>
    <div class="carousel grid" :class="rootClasses">
        <div class="carousel--root">
            <div class="carousel--row grid--row">
                <div class="carousel--wrap" :style="wrapStyles">
                    <div class="carousel--item grid--col" v-for="(item, itemIdx) in items"
                            ref="item"
                            :style="itemStyles">
                        <slot name="item" :item="item" :is-active="isActive(itemIdx)" :item-idx="itemIdx">
                            <!-- fallback content -->
                        </slot>
                    </div>
                </div>
            </div>
        </div>
        <div class="carousel--arrows" v-if="showArrowsElement">
            <button type="button" @click.prevent="changeIndex(state.idx - 1)"
                    :disabled="state.idx - 1 < 0 ? true : null"
                    class="carousel--arrow carousel--arrow__prev">
                <span class="carousel--arrow-wrap">
                    <cmp-icon class="carousel--arrow-icon" symbol="chevron_left" size="large"></cmp-icon>
                </span>
            </button>
            <div class="carousel--counter" v-if="showItemCountElement" v-text="itemCount"></div>
            <button type="button" @click.prevent="changeIndex(state.idx + 1)"
                    :disabled="state.idx + 1 > items.length - 1 ? true : null"
                    class="carousel--arrow carousel--arrow__next">
                <span class="carousel--arrow-wrap">
                    <cmp-icon class="carousel--arrow-icon" symbol="chevron_right" size="large"></cmp-icon>
                </span>
            </button>
        </div>
        <div class="carousel--pagination" v-if="showPaginationElement">
            <ul class="u-reset carousel--bullets">
                <li class="carousel--bullet" v-for="(item, itemIdx) in items">
                    <button class="btn btn__pagination"
                            :data-active="state.idx === itemIdx"
                            @click.prevent="onRequestChange(itemIdx)">
                    </button>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'vue/mixins/bem';
    import uiPatternMixin from 'vue/mixins/ui-pattern';


    export default {
        mixins: [
            bemMixin('carousel'),
            uiPatternMixin('idx'),
        ],
        props: {
            items: {
                type: Array,
                required: true,
            },
            idx: {
                type: Number,
                default: 0,
            },
            showPagination: {
                type: Boolean,
                default: true,
            },
            showArrows: {
                type: Boolean,
                default: true,
            },
            showItemCount: {
                type: Boolean,
                default: false,
            },
            preloadRange: {
                type: Number,
                default: 0,
            },
            allowArrowKeys: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                state: {},
            };
        },
        computed: {
            rootClasses() {
                return [
                    this.bemFacet,
                ];
            },
            wrapStyles() {
                return {
                    width: `${ this.items.length * 100 }%`,
                    transform: `rotateZ(1turn) translateX(${ this.state.idx * -100 / this.items.length }%)`,
                };
            },
            itemStyles() {
                const itemWidth = 100 / this.items.length;

                return {
                    width: `${ itemWidth }%`,
                };
            },
            itemCount() {
                return `${ this.state.idx + 1 } / ${ this.items.length }`;
            },
            showArrowsElement() {
                return this.showArrows && this.items.length > 1;
            },
            showPaginationElement() {
                return this.showPagination && this.items.length > 1;
            },
            showItemCountElement() {
                return this.showItemCount && this.items.length > 1;
            },
        },
        methods: {
            onKeyPressed: function(e) {
                // NOTE: Don't respond to key presses, when there is an active element
                var hasActiveELement = document.activeElement && document.activeElement !== document.body;

                if (hasActiveELement || !this.allowArrowKeys) {
                    return;
                }

                switch (e.keyCode) {
                    // RIGHT
                    case 39:
                        this.changeIndex(this.state.idx + 1);
                        break;
                    // LEFT
                    case 37:
                        this.changeIndex(this.state.idx - 1);
                        break;
                    default:
                        break;
                }
            },
            changeIndex(newIndex) {
                if (newIndex < 0 || newIndex > this.items.length - 1) {
                    return;
                }

                this.onRequestChange(newIndex);
            },
            isActive(itemIdx) {
                return Math.abs(itemIdx - this.state.idx) <= this.preloadRange;
            },
        },
        created: function() {
            document.addEventListener('keyup', this.onKeyPressed);
        },
        destroyed: function() {
            document.removeEventListener('keyup', this.onKeyPressed);
        },
    };
</script>



// WEBPACK FOOTER //
// index.vue?22392796